import React from 'react';
import { ResponseStatusAvatar, responseStatusAdminId } from '../../workAvailability/ResponseStatusProvider';
import ChatMessageRow from './ChatMessageRow';
import ChatLinkPreviewList from './ChatLinkPreviewList';
import { buildEventMessageRowViewModel } from './eventMessageRowViewUtils';
import ChatQuestionCard from '../questions/ChatQuestionCard';
import ChatWorkAvailabilityNotices from './ChatWorkAvailabilityNotices';

export default function EventStandardMessageRow({
  message,
  activeAnchorMessageId = '',
  isAnnouncement = false,
  isMyMessage = false,
  hideSenderMeta = false,
  shouldSubtractSelfRead = false,
  getMainPartLabel,
  getAnnouncementSenderName,
  senderNameFallback,
  bubbleClassByType,
  useFullWidthPartParentheses = false,
  variant = 'plain',
  formatDateTime,
  resolveMessageSourceBadgeLabel,
  shouldShowMessageSourceBadge,
  sourceBadgeClassName = '',
  renderAnnouncementAvatarLeft,
  renderAdminAvatarLeft,
  renderArtistAvatarLeft,
  onAvatarClick,
  rowClassName = '',
  bubbleClassName = '',
  onContextMenu,
  onTouchStart,
  onTouchEnd,
  onTouchCancel,
  onTouchMove,
  sideActionContent = null,
  replyHeaderContent = null,
  renderMessageContent,
  footerContent = null,
  metaEndContent = null,
}) {
  const sourceEventLabel = resolveMessageSourceBadgeLabel?.(message);
  const showSourceBadge = shouldShowMessageSourceBadge?.(message);
  const timeLabel = typeof formatDateTime === 'function'
    ? formatDateTime(message?.created_at)
    : '';

  const rowProps = buildEventMessageRowViewModel({
    message,
    isAnnouncement,
    isMyMessage,
    hideSenderMeta,
    shouldSubtractSelfRead,
    getMainPartLabel,
    getAnnouncementSenderName,
    senderNameFallback,
    bubbleClassByType,
    useFullWidthPartParentheses,
    variant,
    timeLabel,
    activeAnchorMessageId,
    sourceEventLabel,
    showSourceBadge,
    sourceBadgeClassName,
    renderAnnouncementAvatarLeft,
    renderAdminAvatarLeft,
    renderArtistAvatarLeft,
    onAvatarClick,
    onContextMenu,
    onTouchStart,
    onTouchEnd,
    onTouchCancel,
    onTouchMove,
  });

  const linkPreviewCards = message?.linkPreview || message?.linkPreviews?.length
    ? <ChatLinkPreviewList message={message} />
    : null;
  const questionCard = message?.question ? <ChatQuestionCard question={message.question} /> : null;
  const hasAvailabilityNotice = Array.isArray(message?.work_availability_notices)
    ? message.work_availability_notices.length > 0
    : Array.isArray(message?.workAvailabilityNotices) && message.workAvailabilityNotices.length > 0;
  const availabilityNotice = hasAvailabilityNotice ? <ChatWorkAvailabilityNotices message={message} /> : null;
  const mergedFooter = (linkPreviewCards || questionCard || footerContent || availabilityNotice)
    ? (<>{linkPreviewCards}{questionCard}{availabilityNotice}{footerContent}</>)
    : null;

  return (
    <ChatMessageRow
      topicMessage={message}
      {...rowProps}
      avatarNode={rowProps.avatarNode ? <ResponseStatusAvatar adminUserId={responseStatusAdminId(message)} badgePlacement="avatar">{rowProps.avatarNode}</ResponseStatusAvatar> : null}
      rowClassName={rowClassName}
      bubbleClassName={bubbleClassName ? `${rowProps.bubbleClassName || ''} ${bubbleClassName}`.trim() : rowProps.bubbleClassName}
      sideActionContent={sideActionContent}
      footerContent={mergedFooter}
      metaEndContent={metaEndContent}
    >
      <>
        {replyHeaderContent}
        {typeof renderMessageContent === 'function' ? renderMessageContent(message) : null}
      </>
    </ChatMessageRow>
  );
}
